import {server} from '../Data/BuildEnvironment'
import {HttpRequest} from '../Data/HttpRequest'

export function createWithTranslation(
    input: string,
    translation: string
): HttpRequest {
    return {
        verb: 'POST',
        url: `${server}/messages/create-with-translation`,
        headers: {Accept: 'application/json'},
        body: JSON.stringify({input, translation}),
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/MessageResource.ts